import { Box, Stack, Typography } from '@mui/material';
import type { MediaSize } from 'react-easy-crop';

import { CropPreview } from '@modules/_shared/components/image-upload/components/CropPreview';
import type { CropArea } from '@modules/_shared/components/image-upload/types';

const CARD_WIDTH = 320;
const COVER_WIDTH = CARD_WIDTH - 2;

export const CoverPreview = ({
  imageUrl,
  mediaSize,
  cropArea,
  rotation,
  aspectRatio,
  isImageLoading,
  label,
  logoUrl,
}: {
  imageUrl: string;
  mediaSize: MediaSize | null;
  cropArea: CropArea | null;
  rotation: number;
  aspectRatio: number;
  isImageLoading: boolean;
  label?: string | null;
  logoUrl?: string | null;
}) => (
  <Box
    sx={{
      width: CARD_WIDTH,
      maxWidth: '100%',
      flexShrink: 0,
      alignSelf: 'flex-start',
      borderRadius: '10px',
      overflow: 'hidden',
      border: 1,
      borderColor: 'divider',
      bgcolor: 'background.paper',
    }}
  >
    {isImageLoading ? (
      <Box sx={{ aspectRatio: String(aspectRatio), bgcolor: 'grey.100' }} />
    ) : (
      <CropPreview
        imageUrl={imageUrl}
        mediaSize={mediaSize}
        cropArea={cropArea}
        rotation={rotation}
        width={COVER_WIDTH}
        aspectRatio={aspectRatio}
        round={false}
        flush
      />
    )}
    {(logoUrl || label) && (
      <Stack
        direction="row"
        spacing={1.5}
        sx={{
          alignItems: 'flex-end',
          px: 1.5,
          pb: 1.5,
          pt: logoUrl ? 0 : 1.5,
          mt: logoUrl ? -3 : 0,
          position: 'relative',
        }}
      >
        {logoUrl && (
          <Box
            sx={{
              width: 48,
              height: 48,
              flexShrink: 0,
              borderRadius: '10px',
              border: '2px solid',
              borderColor: 'background.paper',
              bgcolor: 'common.white',
              overflow: 'hidden',
            }}
          >
            <Box
              component="img"
              src={logoUrl}
              alt=""
              sx={{
                display: 'block',
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </Box>
        )}
        {label && (
          <Typography noWrap sx={{ fontWeight: 500, minWidth: 0 }}>
            {label}
          </Typography>
        )}
      </Stack>
    )}
  </Box>
);
